export const ENABLED_EXTRA_MODULES = {
  RECURRING_TRANSACTIONS: true,
  NETWORK: false,
  EXTENSIONS: true,
  VOICE_ASSISTANTS: true,
  AUTO_UI: false,
};
